
const newModel = () => {
    return {
        duanDautuId: null,
        sttBaocao: null,
        ten: null,
        nguonvonDautuId: null,
        tenNguonvonDautu: null,
        chuDautu: "UBND TP Sa Đéc",
        thoigianBatdau: null,
        thoigianKetthuc: null,
        tongmucDautu: null,
        tiendoDautuId: null,
        tenTiendoDautu: null,
        tinhhinhTrienkhai: null,
        duanDautuLienquanId: null,
        kehoachVonInfo: [], //Sử dụng cho infor
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        duanDautuId: null,
        sttBaocao: null,
        ten: null,
        nguonvonDautuId: null,
        chuDautu: "UBND TP Sa Đéc",
        thoigianBatdau: null,
        thoigianKetthuc: null,
        tongmucDautu: null,
        tiendoDautuId: null,
        tinhhinhTrienkhai: null,
        duanDautuLienquanId: null,
        kehoachVonInfo: [], //Sử dụng cho infor


        KHV_idKy: null,
        KHV_namtruocChuyensang: null,
        KHV_vonphankhaiTrongnam: null,
        KHV_uocnamtruocChuyensang: null,
        KHV_ghiChu: null,
        KHV_stt: '0',
        KHV_enabled: true,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        duanDautuId: item.duanDautuId,
        sttBaocao: item.sttBaocao,
        ten: item.ten,
        nguonvonDautuId: item.nguonvonDautuId,
        tenNguonvonDautu: item.tenNguonvonDautu,
        chuDautu: item.chuDautu,
        thoigianBatdau: item.thoigianBatdau,
        thoigianKetthuc: item.thoigianKetthuc,
        tongmucDautu: item.tongmucDautu,
        tiendoDautuId: item.tiendoDautuId,
        tenTiendoDautu: item.tenTiendoDautu,
        tinhhinhTrienkhai: item.tinhhinhTrienkhai,
        duanDautuLienquanId: item.duanDautuLienquanId,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        duanDautuId: item.duanDautuId,
        sttBaocao: item.sttBaocao,
        ten: item.ten,
        nguonvonDautuId: item.nguonvonDautuId,
        chuDautu: item.chuDautu,
        thoigianBatdau: item.thoigianBatdau,
        thoigianKetthuc: item.thoigianKetthuc,
        tongmucDautu: item.tongmucDautu,
        tiendoDautuId: item.tiendoDautuId,
        tinhhinhTrienkhai: item.tinhhinhTrienkhai,
        duanDautuLienquanId: item.duanDautuLienquanId,
        stt: item.stt,
        KHV_idKy: null,
        KHV_namtruocChuyensang: null,
        KHV_vonphankhaiTrongnam: null,
        KHV_uocnamtruocChuyensang: null,
        KHV_ghiChu: null,
        KHV_stt: '0',
        KHV_enabled: true,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        nguonvonDautuId: null,
        tiendoDautuId: null,
        duanDautuLienquanId: null,
        chuDautu: null,
        sttBaocao: null,
        thoigianBatdauTungay: null,
        thoigianBatdauDenngay: null,
        thoigianKetthucTungay: null,
        thoigianKetthucDenngay: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        nguonvonDautuId: item.nguonvonDautuId,
        tiendoDautuId: item.tiendoDautuId,
        duanDautuLienquanId: item.duanDautuLienquanId,
        chuDautu: item.chuDautu,
        sttBaocao: item.sttBaocao,
        thoigianBatdauTungay: item.thoigianBatdauTungay,
        thoigianBatdauDenngay: item.thoigianBatdauDenngay,
        thoigianKetthucTungay: item.thoigianKetthucTungay,
        thoigianKetthucDenngay: item.thoigianKetthucDenngay,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        duanDautuId: null,
        sttBaocao: null,
        ten: null,
        nguonvonDautuId: null,
        chuDautu: null,
        duanDautuLienquanId: null,
        thoigianBatdau: null,
        thoigianKetthuc: null,
        tongmucDautu: null,
        tiendoDautuId: null,
        tinhhinhTrienkhai: null,
        KHV_idKy: null,
        KHV_namtruocChuyensang: null,
        KHV_vonphankhaiTrongnam: null,
        KHV_uocnamtruocChuyensang: null,
        KHV_ghiChu: null,
        KHV_stt: null,
        KHV_enabledDisplay: null,
        stt: null,
        enabled: null,
    }
}

export const duanDautuModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


